module.exports = __webpack_public_path__ + "de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/de.svg
// module id = 771
// module chunks = 0